"use client";
import { jsx as f } from "react/jsx-runtime";
import l from "clsx";
import p from "next/link";
import { memo as z } from "react";
import '../assets/Typography.css';const m = "_title_16cgr_1", u = "_subtitle_16cgr_1", d = "_white_16cgr_4", x = "_violet_16cgr_11", N = "_orange_16cgr_18", y = "_gray_16cgr_25", v = "_red_16cgr_32", T = "_notice_16cgr_39", b = "_font_size__10_16cgr_46", k = "_font_size__12_16cgr_49", L = "_font_size__14_16cgr_52", D = "_font_size__16_16cgr_55", R = "_font_size__18_16cgr_58", S = "_font_size__20_16cgr_61", j = "_font_size__24_16cgr_64", C = "_font_size__28_16cgr_67", q = "_font_size__32_16cgr_70", A = "_font_size__36_16cgr_73", B = "_font_size__38_16cgr_76", E = "_font_size__42_16cgr_79", F = "_font_size__56_16cgr_82", G = "_font_size__64_16cgr_85", H = "_font_size__inherit_16cgr_88", I = "_font_weight__300_16cgr_91", J = "_font_weight__400_16cgr_94", K = "_font_weight__500_16cgr_97", M = "_font_weight__600_16cgr_100", O = "_font_weight__700_16cgr_103", P = "_font_weight__800_16cgr_106", Q = "_font_weight__900_16cgr_109", U = "_font_weight__inherit_16cgr_112", V = "_line_height__80_16cgr_115", W = "_line_height__100_16cgr_118", X = "_line_height__110_16cgr_121", Y = "_line_height__120_16cgr_124", Z = "_line_height__130_16cgr_127", $ = "_line_height__140_16cgr_130", __ = "_line_height__150_16cgr_133", t_ = "_line_height__inherit_16cgr_136", e_ = "_text_16cgr_144", n_ = "_content_text_16cgr_274", i_ = "_reverse_discount_16cgr_401", o_ = "_link_16cgr_501", s_ = "_center_16cgr_636", c_ = "_upper_16cgr_646", _ = {
  title: m,
  subtitle: u,
  white: d,
  violet: x,
  orange: N,
  gray: y,
  red: v,
  notice: T,
  font_size__10: b,
  font_size__12: k,
  font_size__14: L,
  font_size__16: D,
  font_size__18: R,
  font_size__20: S,
  font_size__24: j,
  font_size__28: C,
  font_size__32: q,
  font_size__36: A,
  font_size__38: B,
  font_size__42: E,
  font_size__56: F,
  font_size__64: G,
  font_size__inherit: H,
  font_weight__300: I,
  font_weight__400: J,
  font_weight__500: K,
  font_weight__600: M,
  font_weight__700: O,
  font_weight__800: P,
  font_weight__900: Q,
  font_weight__inherit: U,
  line_height__80: V,
  line_height__100: W,
  line_height__110: X,
  line_height__120: Y,
  line_height__130: Z,
  line_height__140: $,
  line_height__150: __,
  line_height__inherit: t_,
  text: e_,
  content_text: n_,
  reverse_discount: i_,
  link: o_,
  center: s_,
  upper: c_
}, h_ = z(
  ({
    text: t,
    center: e,
    upper: n,
    color: i = "white",
    Component: o = "h1",
    fontSize: s = 28,
    fontWeight: c = 700,
    lineHeight: h = 130,
    className: g,
    ...r
  }) => /* @__PURE__ */ f(
    o,
    {
      className: l(
        _.title,
        _[i],
        _["font_size__" + s],
        _["font_weight__" + c],
        _["line_height__" + h],
        {
          [_.center]: e,
          [_.upper]: n
        },
        g
      ),
      ...r,
      children: t
    }
  )
);
h_.displayName = "Title";
const g_ = z(
  ({
    text: t,
    center: e,
    upper: n,
    color: i = "white",
    Component: o = "span",
    fontSize: s = 24,
    fontWeight: c = 700,
    lineHeight: h = 130,
    className: g,
    ...r
  }) => /* @__PURE__ */ f(
    o,
    {
      className: l(
        _.subtitle,
        _[i],
        _["font_size__" + s],
        _["font_weight__" + c],
        _["line_height__" + h],
        {
          [_.center]: e,
          [_.upper]: n
        },
        g
      ),
      ...r,
      children: t
    }
  )
);
g_.displayName = "Subtitle";
const r_ = z(
  ({
    text: t,
    center: e,
    upper: n,
    color: i = "white",
    Component: o = "span",
    fontSize: s = 18,
    fontWeight: c = 400,
    lineHeight: h = 150,
    className: g,
    ...r
  }) => /* @__PURE__ */ f(
    o,
    {
      className: l(
        _.text,
        _[i],
        _["font_size__" + s],
        _["font_weight__" + c],
        _["line_height__" + h],
        {
          [_.center]: e,
          [_.upper]: n
        },
        g
      ),
      ...r,
      children: t
    }
  )
);
r_.displayName = "Text";
const f_ = z(
  ({
    text: t,
    center: e,
    upper: n,
    color: i = "gray",
    Component: o = "span",
    fontSize: s = 16,
    fontWeight: c = 400,
    lineHeight: h = 150,
    className: g,
    ...r
  }) => /* @__PURE__ */ f(
    o,
    {
      className: l(
        _.content_text,
        _[i],
        _["font_size__" + s],
        _["font_weight__" + c],
        _["line_height__" + h],
        {
          [_.center]: e,
          [_.upper]: n
        },
        g
      ),
      ...r,
      children: t
    }
  )
);
f_.displayName = "ContentText";
const l_ = z(
  ({
    href: t,
    text: e,
    center: n,
    upper: i,
    color: o = "orange",
    fontSize: s = "inherit",
    fontWeight: c = "inherit",
    lineHeight: h = "inherit",
    className: g,
    onClick: r,
    ...a
  }) => /* @__PURE__ */ f(
    p,
    {
      href: t,
      onClick: (w) => {
        r == null || r(
          w
        );
      },
      className: l(
        _.link,
        _[o],
        _["font_size__" + s],
        _["font_weight__" + c],
        _["line_height__" + h],
        {
          [_.center]: n,
          [_.upper]: i
        },
        g
      ),
      ...a,
      children: e
    }
  )
);
l_.displayName = "TextLink";
const z_ = z(
  ({
    text: t,
    center: e,
    upper: n,
    Component: i = "span",
    fontSize: o = 14,
    fontWeight: s = 400,
    lineHeight: c = 130,
    className: h,
    ...g
  }) => /* @__PURE__ */ f(
    i,
    {
      className: l(
        _.reverse_discount,
        _["font_size__" + o],
        _["font_weight__" + s],
        _["line_height__" + c],
        {
          [_.center]: e,
          [_.upper]: n
        },
        h
      ),
      ...g,
      children: t
    }
  )
);
z_.displayName = "ReverseDiscount";
export {
  f_ as ContentText,
  z_ as ReverseDiscount,
  g_ as Subtitle,
  r_ as Text,
  l_ as TextLink,
  h_ as Title
};
